import { IStoryContent } from '@opengov/stories-shared/types';
import {
  processStoryContentOrTemplateContent,
  getStoryContentsById,
  getTemplateContentsById
} from '@opengov/stories-shared/graphQL';
import { orderStoryContents, sortStoryContents } from '@opengov/stories-shared/utils';
import { postJson } from '../../../../utils/fetchUtils';

export type FetchStoryContentsParams = {
  storyId: string;
  entityId: number;
  isTemplate?: boolean;
};

export type IStoryContentsGraphQLResponse = {
  data?: {
    storyContents?: IStoryContent[];
  };
  errors?: { message: string }[];
};

/**
 * Utility function to fetch story contents
 * Used by useExportStoryPdf and useFetchStoryContents
 */
export const fetchStoryContents = async ({
  storyId,
  entityId,
  isTemplate = false
}: FetchStoryContentsParams): Promise<IStoryContent[]> => {
  let variables: { [key: string]: string | number } = {
    [isTemplate ? 'storyTemplateId' : 'storyId']: storyId,
    limit: 100
  };

  if (!isTemplate) {
    variables = {
      ...variables,
      entityId
    };
  }

  const response = await postJson<IStoryContentsGraphQLResponse>('/api/data/objects/stories/v1/graphql', {
    query: isTemplate ? getTemplateContentsById : getStoryContentsById,
    variables
  });

  if (response.data?.storyContents) {
    let storyContents: IStoryContent[] = response.data.storyContents.map(processStoryContentOrTemplateContent);
    storyContents = orderStoryContents(sortStoryContents(storyContents));
    return storyContents;
  }

  if (response.errors) {
    throw new Error(response.errors[0]?.message || 'Failed to fetch story contents');
  }

  return [];
};
